export default __webpack_public_path__ + "static/referral-banner-5739e894bd53c1c9af14b300f44866e4.jpg";